import type { RoutePath } from "./types";

const ROUTES: RoutePath[] = ["/", "/music", "/art", "/games", "/about"];

function normalizePath(path: string): RoutePath {
  let p = path === "" ? "/" : path;
  if (p.length > 1 && p.endsWith("/")) p = p.slice(0, -1);
  if (ROUTES.includes(p as RoutePath)) return p as RoutePath;
  return "/";
}

export function getPath(): RoutePath {
  return normalizePath(window.location.pathname || "/");
}

export function currentLocationKey(): string {
  return `${getPath()}${window.location.search}`;
}

function searchToString(search: URLSearchParams | string | undefined): string {
  if (search == null || search === "") return "";
  if (typeof search === "string") {
    if (search === "?") return "";
    return search.startsWith("?") ? search : `?${search}`;
  }
  const q = search.toString();
  return q ? `?${q}` : "";
}

/** 站内路由；search 可为 `?track=1` 或 URLSearchParams */
export function navigate(path: RoutePath, search?: URLSearchParams | string): void {
  const s = searchToString(search);
  const next = path + s;
  if (currentLocationKey() === next) return;
  window.history.pushState({}, "", next);
  window.dispatchEvent(new PopStateEvent("popstate"));
}

export function onRouteChange(handler: () => void): void {
  window.addEventListener("popstate", handler);
}

export function interceptNavLinks(root: HTMLElement): void {
  root.addEventListener("click", (e) => {
    const t = e.target as HTMLElement | null;
    const a = t?.closest("a") as HTMLAnchorElement | null;
    if (!a || !root.contains(a)) return;
    const href = a.getAttribute("href");
    if (!href || href.startsWith("//") || href.includes("://")) return;
    if (!href.startsWith("/")) return;

    const u = new URL(href, window.location.origin);
    const path = normalizePath(u.pathname);
    if (!ROUTES.includes(path)) return;

    const next = path + u.search + u.hash;
    if (currentLocationKey() === next) {
      e.preventDefault();
      return;
    }
    e.preventDefault();
    window.history.pushState({}, "", next);
    window.dispatchEvent(new PopStateEvent("popstate"));
  });
}
